import { useToken } from "@chakra-ui/react";

type Props = (themeKey: string, subkey: string | string[]) => string[];

const useThemeToken: Props = (themeKey, subkey) => {
  const tokens: string[] = useToken(
    // the key within the theme, in this case `theme.colors`
    themeKey,
    // the subkey(s), resolving to `theme.colors.red.100`
    Array.isArray(subkey) ? subkey : [subkey]
  );

  return tokens;
};

export default useThemeToken;
